export default {
  computed: {
    computedSummer10cm2018Visibility() {
      return this.$store.state.imagryLayers.summer10cm2018.visibility;
    }
  },
  methods: {
    mapLayerSat10cmSummer2018Add() {
      this.map.addSource("sat-2018-10cm-tiles", {
        type: "raster",
        tiles: [
          "https://storage.googleapis.com/map-tiles-wbsnow/10cm_2018_summer_v2/{z}/{x}/{y}.png"
        ],
        tileSize: 512
      });

      this.map.addLayer({
        id: "sat-2018-10cm-tiles",
        type: "raster",
        source: "sat-2018-10cm-tiles",
        layout: {
          visibility: "visible"
        }
      });

      this.map.moveLayer("sat-2018-10cm-tiles", "marker-layer-bottom");
    },
    mapLayerSat10cmSummer2018Remove() {
      this.map.removeLayer("sat-2018-10cm-tiles");
      this.map.removeSource("sat-2018-10cm-tiles");
    }
  },
  watch: {
    "$store.state.imagryLayers.summer10cm2018.visibility": function(newValue) {
      if (newValue === true) {
        this.mapLayerSat10cmSummer2018Add();
      } else {
        this.mapLayerSat10cmSummer2018Remove();
      }
    }
  }
};
